const colors = [
  '#69d2e7',
  '#a7dbd8',
  '#e0e4cc',
  '#f38630',
  '#fa6900',
  '#fe4365',
  '#fc9d9a',
  '#f9cdad',
  '#c8c8a9',
  '#83af9b',
  '#ecd078',
  '#d95b43',
  '#c02942',
  '#542437',
  '#53777a',
  '#556270',
  '#4ecdc4',
  '#c7f464',
  '#ff6b6b',
  '#c44d58',
  '#774f38',
  '#e08e79',
  '#f1d4af',
  '#ece5ce',
  '#c5e0dc',
  '#e8ddcb',
  '#cdb380',
  '#036564',
  '#033649',
  '#490a3d',
  '#bd1550',
  '#e97f02',
  '#f8ca00',
  '#8a9b0f',
  '#594f4f',
  '#547980',
  '#45ada8',
  '#9de0ad',
  '#e5fcc2',
  '#00a0b0',
  '#6a4a3c',
  '#cc333f',
  '#eb6841',
  '#edc951',
  '#e94e77',
  '#d68189',
  '#c6a49a',
  '#c6e5d9',
  '#f4ead5',
  '#3fb8af',
  '#7fc7af',
  '#dad8a7',
  '#ff9e9d',
  '#ff3d7f',
  '#d9ceb2',
  '#948c75',
  '#d5ded9',
  '#7a6a53',
  '#99b2b7',
  '#cbe86b',
  '#f2e9e1',
  '#cbe86b',
  '#dce9be',
  '#555152',
  '#2e2633',
  '#99173c',
  '#005f6b',
  '#008c9e',
  '#00b4cc',
  '#00dffc',
  '#413e4a',
  '#73626e',
  '#b38184',
  '#f0b49e',
  '#f7e4be',
  '#ff4e50',
  '#fc913a',
  '#f9d423',
  '#ede574',
  '#e1f5c4',
  '#99b898',
  '#fecea8',
  '#ff847c',
  '#e84a5f',
  '#655643',
  '#80bca3',
  '#f6f7bd',
  '#e6ac27',
  '#bf4d28',
  '#00a8c6',
  '#40c0cb',
  '#aee239',
  '#8fbe00',
];

function getHash(input) {
  let hash = 0;
  const len = input.length;
  for (let i = 0; i < len; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // to 32bit integer
  }
  return Math.abs(hash);
}

function getColorFromString(str: string) {
  const num = getHash(str);
  const index = num % colors.length;

  return colors[index];
}

export { getColorFromString };
